import { useLocation, useParams } from 'react-router-dom';
import { saveVisit } from '../../api/visitTrackerService';
import { RENEW_RETURN_URL_KEY } from '../../stores/renewStore';

//Shared by /payment/cancel (a new purchase) and /renew/cancel (a renewal checkout). A renewing
//customer is sent back to the renew page they came from - never to a fresh purchase.
const PaymentCancel = () => {
    const { paymentId } = useParams();
    const { pathname } = useLocation();
    const isRenewal = pathname.startsWith('/renew/');
    saveVisit((isRenewal ? 'renew-cancel' : 'payment-cancel') + ' PaymentId: ' + paymentId);

    let renewUrl = '/subscriptions';
    if (isRenewal) {
        try {
            const remembered = sessionStorage.getItem(RENEW_RETURN_URL_KEY);
            if (remembered && remembered.startsWith(window.location.origin)) renewUrl = remembered;
        } catch { }
    }

    return (
        <div className="page-wrap">
            <div className="cancel-wrap">
                <div className="result-icon cancel-icon">
                    <svg fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" width="30" height="30">
                        <circle cx="12" cy="12" r="10"/>
                        <line x1="15" y1="9" x2="9" y2="15"/>
                        <line x1="9" y1="9" x2="15" y2="15"/>
                    </svg>
                </div>

                <h1>{isRenewal ? 'Renewal cancelled' : 'Payment cancelled'}</h1>
                <p className="success-lede">
                    {isRenewal ? 'Your renewal was cancelled and ' : 'Your payment was cancelled and '}
                    <strong>no charges were made</strong>.
                </p>

                <div className="reassure">
                    <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" width="13" height="13" style={{ color: 'var(--warn)' }}>
                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                    </svg>
                    No charges were made to your payment method
                </div>

                <div className="result-actions">
                    {isRenewal ? (
                        <a href={renewUrl} className="btn btn-primary">
                            <svg fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" width="14" height="14">
                                <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/>
                            </svg>
                            Back to your renewal
                        </a>
                    ) : (
                        <a href="/purchase" className="btn btn-primary">
                            <svg fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" width="14" height="14">
                                <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/>
                            </svg>
                            Try again
                        </a>
                    )}
                    <a href={isRenewal ? '/subscriptions' : 'https://desktopcallrecorder.com/'} className="btn btn-outline">
                        {isRenewal ? 'Your subscriptions' : 'Back to home'}
                    </a>
                </div>

                <div className="helpers">
                    {!isRenewal && (
                        <a href="/purchase" className="help-link">
                            <div className="help-icon">
                                <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" width="16" height="16">
                                    <rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/>
                                </svg>
                            </div>
                            <div className="help-text">
                                <h3>Change number of computers</h3>
                                <p>Pick a different licence quantity</p>
                            </div>
                        </a>
                    )}
                    <a href="mailto:team@desktopcallrecorder.com" className="help-link">
                        <div className="help-icon">
                            <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" width="16" height="16">
                                <circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/>
                            </svg>
                        </div>
                        <div className="help-text">
                            <h3>Trouble with payment?</h3>
                            <p>Our team can help</p>
                        </div>
                    </a>
                </div>

                <p className="result-support">
                    Need assistance? Email <a href="mailto:team@desktopcallrecorder.com">team@desktopcallrecorder.com</a>
                </p>
            </div>
        </div>
    );
};

export default PaymentCancel;
